import type { ChatbotPrompt } from '@repo/types';
import { useEffect, useRef } from 'react';

import { useAnalytics } from '../../../contexts/analytics/AnalyticsProvider';
import { useTinyAIDisplayLocation } from '../../../hooks/useTinyAIDisplayLocation';
import { useTinyAIPageContext } from '../../../hooks/useTinyAIPageContext';

interface UseTinyAIPromptShownAnalyticsOptions {
  prompts: ChatbotPrompt[] | undefined;
  hasMessages: boolean;
}

export const useTinyAIPromptShownAnalytics = ({
  prompts,
  hasMessages,
}: UseTinyAIPromptShownAnalyticsOptions) => {
  const { trackEvent } = useAnalytics();
  const pageContext = useTinyAIPageContext();
  const displayLocation = useTinyAIDisplayLocation();

  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) return;
    if (!prompts || prompts.length === 0) return;
    if (hasMessages) return;

    hasTrackedRef.current = true;
    trackEvent('TinyAI prompt hook shown', {
      display_location: displayLocation!,
      prompt_count: prompts.length,
      page_context: pageContext,
    });
  }, [prompts, hasMessages, displayLocation, trackEvent, pageContext]);
};
